import Layout from "../../components/layout";
import { GetStaticProps } from "next";
import Link from "next/link";
import React from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';
import "../../styles/scss/blog.module.scss";

import Image from "next/image";
const validSpeakers = [{
  speakerName: "Keval Bhogayata",
  speakersProfile: {
    altText: "Keval Bhogayata",
    sourceUrl: "/images/podcast/Keval-Bhogayata-Speaker.webp",
  },
  speakerdesignation: "Principal Engineer, Middleware ",
}]
export default function DineWithDevopsBengaluru2025({ props }) {
    const { t } = useTranslation('common');
    return (
        <>
            <Layout isHomePage={false} pageTitle={"Join Middleware at Dine With DevOps VI Bengaluru, May 15, 2026"}
                ogImage={"/images/events/dine-with-devops-bengaluru-2026.webp"}
                uri={"/events/dine-with-devops-bengaluru-2026/"}
                metaTitle={"Join Middleware at Dine With DevOps VI Bengaluru, May 15, 2026"}
                metaDesc={"Meet the Middleware team at Dine With DevOps VI, Bengaluru on May 15, 2026 at The Ritz-Carlton. Explore full-stack observability, OpsAI SRE Agent, and connect with India's top DevOps and engineering leaders."}
                metaRobotsNoindex={"index"}
                metaRobotsNofollow={"follow"}>

                <div className={'global-wrapper single-blog-v2'} >
                    <div className={"event-page dine-with-devops blog-main-content webinar-main-content"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'} style={{alignItems: 'start', gap: "40px"}}>
                                    <div className={'main-content webinar-hero-section'}>
                                        <Link href={"/events/"} className={"back-to-blog"}>Back to Event List</Link>
                                        <div className={'d-flex aws-mw'}>

                                        </div>
                                        <div className={'inner-hero'}>
                                            <h1>Join Middleware at <span>Dine With DevOps VI</span> Bengaluru 2026!</h1>
                                                                <div className={"category-episode"}>
                      {["Dine with DevOps", "Observability", "Bangalore", "15 May ‘26"].map((tag, index) => (
                        <div
                          className={`category ${index === 0 ? "gradient-category" : "gray"}`}
                          key={`tag-${tag}-${index}`}
                        >
                          {tag}
                        </div>
                      ))}
                    </div>
                                            <p><b>Date: </b>May 15th 2026</p>
                                            <p><b>Venue: </b> The Ritz-Carlton, Bangalore</p>
                                        </div>
                                        <p className="event-dine-with-devops-description">Connect with our team at <Link href={"https://www.dinewithdevops.com/"} target={"_blank"}>Dine with DevOps VI</Link> to discover how Middleware's full-stack observability platform and AI SRE Agent help you detect issues faster, resolve incidents automatically, and keep your systems running at peak performance.</p>

                                        <img
                                        style={{width: "100%"}}
                                            src={'/images/events/dine-with-devops-bengaluru-2026-event.webp'} alt={'Join Middleware at Dine With DevOps VI Bengaluru 2026!'} width={"100%"} height={"100%"} />
                                       <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={''}>
                                    <h4 style={{paddingTop: '8px'}}>Meet Our Team</h4>
                                    <Image style={{width: "100%"}} src={'/images/events/meet-our-team-events.webp'} width={1776} height={392} alt="Meet Our Team" />
                                   <blockquote style={{marginTop: "40px"}}> 
                                    <ul>
                                        <li><Link href={"https://www.linkedin.com/in/sawaramsuthar/"}
                                            target={"_blank"}>Sam Suthar</Link>, Founding Director, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/vivektilva/"} target={"_blank"}>Vivek
                                            Tilva</Link>, Product Manager, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/bhogayatakb/"} target={"_blank"}>Keval
                                            Bhogayata </Link>, Principal Engineer, Middleware (Speaker)
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/malay-tanna/"}
                                            target={"_blank"}>Malay Tanna</Link>, GTM Lead, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/anshuman-mishra-83a069233/"}
                                            target={"_blank"}>Anshuman Mishra</Link>, Senior SDR, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/goutham-k-1198ab16a/"}
                                            target={"_blank"}>Goutham K</Link>, Technical Sales Engineer, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/anurag-bose/"}
                                            target={"_blank"}> Anurag Bose</Link>, GTM Lead, Middleware</li>
                                        
                                    </ul>
</blockquote>
                                    <h4>What’s Middleware All About?</h4>
                                    <p>Middleware is a full-stack observability platform that detects issues across infrastructure, APM, and real user monitoring and resolves them automatically using the AI SRE Agent. From root cause to fix, Middleware closes the loop so your team spends less time firefighting and more time building.
                                    </p>

                                    <h4>What does that mean for your business?</h4>
                                    <p>Upto 10X reduction in observability costs</p>
                                    <p>Upto 75% improvement in operational efficiency</p>
                                    <p>Upto 20% faster time to resolution (MTTR)</p>
                                    <p>Upto 25% improved developer productivity</p>

                                    <h4>Middleware’s Observability Suite Includes: </h4>

                                    <ul>
                                        <li><b>OpsAI SRE Agent:</b> AI-powered SRE agent that automatically detects production issues, pinpoints the exact line of code, and opens a pull request with the fix before you finish reading the alert.
                                        </li>
                                        <li><b>Infrastructure Monitoring:</b> Monitor and optimize infrastructure in
                                            real-time for peak efficiency.
                                        </li>
                                        <li><b>Log Monitoring:</b> Unify log data across your tech stack to quickly
                                            identify and fix issues.
                                        </li>
                                        <li><b>APM:</b> Track app performance, identify bottlenecks and fix issues in
                                            real time.
                                        </li>
                                        <li><b>LLM Observability:</b> Monitor, troubleshoot, and optimize LLM
                                            applications in real time.
                                        </li>
                                        <li><b>AI-Powered Dashboards:</b> Leverage intelligent dashboards with automated insights, anomaly detection, and real-time performance analytics.
                                        </li>
                                        <li><b>Database Monitoring:</b> Visualize and track database metrics in real
                                            time for optimal performance.
                                        </li>
                                        <li><b>Synthetic Monitoring:</b> Simulate your app to spot and fix issues before
                                            they affect customers.
                                        </li>
                                        <li><b>Serverless Monitoring:</b> Get full visibility and control over
                                            serverless apps for optimal performance.
                                        </li>
                                        <li><b>Container Monitoring:</b> Get real-time visibility into containerized
                                            apps with data and analytics.
                                        </li>
                                        <li><b>Real User Monitoring:</b> Analyze user journeys on the web and mobile to
                                            optimize performance and experience.
                                        </li>
                                    </ul>

                                    <h4>Middleware at Dine with DevOps VI</h4>
                                    <p>Middleware is the proud Awards Partner for Dine with DevOps VI. Stop by us to see Middleware and OpsAI in action. Talk to our team about how leading engineering organizations are using Middleware to reduce MTTR, eliminate alert fatigue, and move from reactive firefighting to proactive, autonomous operations.</p>
                                    <p>Curious how Middleware can work for your team? <Link
                                        href={"/demo-request/"}>Request a demo</Link> and see it in action.</p>

                                    <h4>Exclusive Gift Hamper!</h4>
                                    <img style={{width: "100%"}} src={"/images/events/middleware-swag.png"} alt={"Middleware Swag"} width={100} height={100} />
                                    <p>Meet the Middleware team and grab an exclusive gift hamper packed with Middleware goodies, stickers, notebooks, tees, and more.</p>
                                </div>


                            </div>
                        </section>
                                    </div>
                                    <div className={'left-block'}>
                                           <div className={"sticky-share podcast-share webinar-share"}>
                    <div className="webinar-share-content">
                      
                        <h3>
                          Reserve Your{" "}
                          <span className="text-gradient">Spot</span>
                        </h3>
                      
                      <div className="date-details">
                        <p>
                          Date: <span>Fri, 15th May 2026</span>
                        </p>
                        <p>
                          Venue:{" "}
                          <span>The Ritz-Carlton, Bangalore</span>
                        </p>
                      </div>

                      <div className="author-list">
                        <div className={"left-guest"}>
                          <h4>Speaker</h4>
                          {validSpeakers.map((speaker, index) => (
                            <div
                              key={`${speaker?.speakerName}-${index}`}
                              className={"flex-guest"}
                            >
                              <img
                               style={{margin: 0, width: 'fit-content'}}
                                src={
                                  speaker?.speakersProfile?.sourceUrl ||
                                  "/images/podcast/default.svg"
                                }
                                alt={
                                  speaker?.speakersProfile?.altText || "Speaker"
                                }
                                width={100}
                                height={100}
                              />
                              <div>
                                <p>{speaker?.speakerName}</p>
                                <p className="speaker-designation">{speaker?.speakerdesignation}</p>
                              </div>
                             
                            </div>
                          ))}
                        </div>
                        <div className="left-guest">
                         <div className="flex-guest">
                            <div>
                                <h4>Topic</h4>
                                <p>From Blind Spots to Actionable Insights: 360° Observability, Driven by Middleware SRE Agent</p>
                              </div>
                              </div>
</div>

                      </div>
                    </div>

                    
                      <div className="surface-iframe-wrap">
                        <iframe
                          id="surface-iframe"
                          src="https://forms.withsurface.com/s/cmowjgt4h000004jis84qoq54"
                          frameBorder="0"
                          allowFullScreen
                          loading="eager"
                          title="Registered DineWithDevOps Event Form"
                        />
                      </div>
                    
                  </div>
                                        
                                    </div>
                                </div>

                            </div>
                        </section>
                    
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    const translations = await serverSideTranslations(
        ctx?.locale ?? "en",
        ["common", "header", "footer"],
        nextI18NextConfig,
    );
    return {


        props: {
            ...translations,
            pageTitle: "Join Middleware at Dine With DevOps VI Bengaluru, May 15, 2026",
            description: "Meet the Middleware team at Dine With DevOps VI, Bengaluru on May 15, 2026 at The Ritz-Carlton. Explore full-stack observability, OpsAI SRE Agent, and connect with India's top DevOps and engineering leaders.",
            ogImage: "/images/events/dine-with-devops-bengaluru-2026.webp",
            uri: "/events/dine-with-devops-bengaluru-2026/",
            metaTitle: "Join Middleware at Dine With DevOps VI Bengaluru, May 15, 2026",
            metaDesc: "Meet the Middleware team at Dine With DevOps VI, Bengaluru on May 15, 2026 at The Ritz-Carlton. Explore full-stack observability, OpsAI SRE Agent, and connect with India's top DevOps and engineering leaders.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
        // revalidate: 10,
    }
}